import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

//TODO: 修改昵称接口
export function editName(name) {
  return request({
    url: '/users/name',
    method: 'put',
    data: {
        name:name,
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js